var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSomethingWrong = function SvgSomethingWrong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 144C134.725 144 140 129.876 140 80C140 30.1241 134.725 16 80 16C25.2747 16 20 30.1241 20 80C20 129.876 25.2747 144 80 144Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.5 53.5C128.5 60.6797 122.68 66.5 115.5 66.5C108.32 66.5 102.5 60.6797 102.5 53.5C102.5 46.3203 108.32 40.5 115.5 40.5C122.68 40.5 128.5 46.3203 128.5 53.5Z",
    fill: "#9C9C9C",
    stroke: "#F4F4F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6911 107.378C30.452 107.378 24.5918 101.518 24.5918 94.2785V61.0993C24.678 53.8602 30.5382 48 37.6911 48C44.9302 48 50.7904 53.8602 50.7904 61.0993V94.2785C50.7904 101.518 44.9302 107.378 37.6911 107.378Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4136 78.9052C42.4981 78.7363 42.4229 78.5311 42.2493 78.4566C42.0901 78.3884 41.9052 78.4556 41.827 78.6102L38.2604 85.6605V81.0068V80.8632V80.7483V70.8376C38.2604 70.5045 37.9903 70.2344 37.6571 70.2344C37.3239 70.2344 37.0538 70.5045 37.0538 70.8376V78.8523L32.9508 72.0412C32.8397 71.8569 32.5952 71.8063 32.4201 71.9314C32.263 72.0436 32.219 72.2579 32.3191 72.423L37.0538 80.2312V135.3H38.2604V87.2118L42.4136 78.9052Z",
    fill: "#DFDFE4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1916 29.7001C31.8916 32.1001 35.1916 32.8001 37.6916 31.1001C40.0917 29.4001 40.7916 26.1001 39.0916 23.6001C37.3916 21.2001 34.0916 20.5001 31.5916 22.2001C29.0916 23.9001 28.4916 27.2001 30.1916 29.7001Z",
    fill: "#9C9C9C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5917 37.0003C20.8917 38.1003 20.4917 40.4003 21.6917 42.1003C22.7917 43.8003 25.0917 44.2003 26.7917 43.0003C28.4917 41.9003 28.8917 39.6003 27.6917 37.9003C26.5917 36.2003 24.2917 35.8003 22.5917 37.0003Z",
    fill: "#9C9C9C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.7 141.9H29.5999C28.8999 141.9 28.3999 142.5 28.3999 143.1C28.3999 143.8 28.9999 144.3 29.5999 144.3H136.7C137.4 144.3 137.9 143.7 137.9 143.1C137.9 142.4 137.4 141.9 136.7 141.9Z",
    fill: "#565656"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 141.9H23.2C22.5 141.9 22 142.5 22 143.1C22 143.8 22.6 144.3 23.2 144.3H25.5C26.2 144.3 26.7 143.7 26.7 143.1C26.8 142.4 26.2 141.9 25.5 141.9Z",
    fill: "#565656"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.6 142.3H38.8999L42.3999 133.4L50.6999 111L57.7999 91.4999L66.0999 69.0999L71.9999 53.6999C73.1999 50.6999 76.0999 48.3999 79.0999 48.3999C81.9999 48.3999 84.9999 50.1999 86.1999 53.6999L92.0999 69.0999L100.4 91.4999L107.5 111L115.8 133.4L118.6 142.3Z",
    fill: "#565656"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12090_579798",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 48,
    width: 81,
    height: 95
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M118.6 142.3H38.8999L42.3999 133.4L50.6999 111L57.7999 91.4999L66.0999 69.0999L71.9999 53.6999C73.1999 50.6999 76.0999 48.3999 79.0999 48.3999C81.9999 48.3999 84.9999 50.1999 86.1999 53.6999L92.0999 69.0999L100.4 91.4999L107.5 111L115.8 133.4L118.6 142.3Z",
    fill: "#999999"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12090_579798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.5 70H56.5V92H101.5V70Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5 111H41.5V133H117.5V111Z",
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.6 142.3H38.3001C35.9001 142.3 33.6001 140.5 33.6001 137.6C33.6001 135.2 35.4001 132.9 38.3001 132.9H118.6C121 132.9 123.3 134.7 123.3 137.6C123.3 140.6 121.5 142.3 118.6 142.3Z",
    fill: "#565656"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.141 120.7C126.641 120.3 129.241 117.1 128.841 113.5C128.441 110 125.241 107.4 121.641 107.8C118.141 108.2 115.541 111.4 115.941 115C116.341 118.5 119.641 121.1 123.141 120.7Z",
    fill: "#565656",
    stroke: "white",
    strokeWidth: 2.2225,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M139.341 137.6C141.941 137.3 143.841 134.9 143.541 132.3C143.241 129.7 140.841 127.8 138.241 128.1C135.641 128.4 133.741 130.8 134.041 133.4C134.441 136 136.741 137.9 139.341 137.6Z",
    fill: "#9C9C9C"
  })));
};
export default SvgSomethingWrong;